import { render } from "./SvgButton.vue?vue&type=template&id=8d84e338&scoped=true"
import script from "./SvgButton.vue?vue&type=script&lang=js"
export * from "./SvgButton.vue?vue&type=script&lang=js"

import "./SvgButton.vue?vue&type=style&index=0&id=8d84e338&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8d84e338"

export default script